export default "__VITE_ASSET__CfbYjOM7__"